export default __webpack_public_path__ + "static/bg-contact-b5e47bd563309c18b58c1f357f716084.jpg";